export const CANCEL_TOKEN_FOR_REPEATED_CALL = 'cancel-token--repeated-call'
export const CANCEL_TOKEN_FOR_PAYLOAD_TOO_BIG = 'cancel-token--payload-too-big'
